/** Shopify CDN: Minification failed

Line 16:136 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:153 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:269 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:331 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:373 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:478 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:522 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:645 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:716 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:760 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 67 more hidden warnings

**/
(self.webpackChunkbreakaway_matcha = self.webpackChunkbreakaway_matcha || []).push([[289], {
    868: function(e, t, s) {
        "use strict";
        var i = s(58);
        new class {
            constructor() {
                this.selectors = {
                    notice: ".js-notice",
                    button: ".js-notice-close"
                },
                this.classes = {
                    hidden: "is-hidden"
                },
                this.init()
            }
            init() {
                this.checkVisiblity(),
                this.bindCloseEvents()
            }
            checkVisiblity() {
              /*
                $(this.selectors.notice).each(((e,t)=>{
                    const s = $(t)
                      , i = $.trim(s.data("id"));
                    
                }
                ))
              */
            }
            bindCloseEvents() {
                $(this.selectors.button).on("click", (e=>{
                  /*
                    const t = $(e.currentTarget).parents(this.selectors.notice);
                    t.addClass(this.classes.hidden),
                    Cookies.set(t.data("id"), 1)
                  */
                }
                ))
            }
        }
        ;
        const a = window.jQuery
          , n = {
            selectors: {
                toggle: ".js-accordion-toggle"
            },
            init(e) {
                this.bindToggleEvent(e)
            },
            bindToggleEvent(e) {
                this.getToggles(e).forEach((t=>{
                    t.addEventListener("click", (()=>{
                        const s = t.parentNode
                          , i = t.nextElementSibling
                          , a = s.classList.contains("is-open");
                        this.a11yToggle(t),
                        this.collapseOpen(e),
                        a || (s.classList.add("is-open"),
                        i.style.maxHeight = `${i.scrollHeight}px`)
                    }
                    ))
                }
                ))
            },
            getToggles(e) {
                return e.querySelectorAll(this.selectors.toggle)
            },
            a11yToggle(e) {
                const t = e.parentNode
                  , s = e.nextElementSibling;
                t.classList.contains("is-open") ? (e.setAttribute("aria-expanded", !1),
                s.setAttribute("aria-hidden", !0)) : (e.setAttribute("aria-expanded", !0),
                s.setAttribute("aria-hidden", !1))
            },
            collapseOpen(e) {
                this.getToggles(e).forEach((e=>{
                    const t = e.parentNode;
                    if (t.classList.contains("is-open")) {
                        this.a11yToggle(e);
                        const s = e.nextElementSibling;
                        t.classList.remove("is-open"),
                        s.style.maxHeight = 0
                    }
                }
                ))
            }
        };
        (0,
        i.z2)("accordion", {
            onLoad() {
                this.$container = a(this.container),
                this.namespace = `.${this.id}`,
                n.init(this.container)
            },
            onUnload() {
                this.$container.off(this.namespace)
            }
        });
        s(521);
        var o = s(750);
        const r = ".js-price-per-serving"
          , c = ".js-price-per-serving-subscribe"
          , l = ".js-price-standard"
          , d = ".js-price-subscription-label"
          , h = ".js-need-a-jar"
          , u = ".js-jar-label"
          , p = ".smartrr-group-active"
          , m = '[name="purchase_option"]'
          , g = ".js-jar-option"
          , b = window.SLS_STATE && window.SLS_STATE.jar_product ? window.SLS_STATE.jar_product : null
          , f = b ? b.variants[1].price : null
          , v = b ? b.variants[2].price : null
          , j = (0,
        o.l)(f, theme.moneyFormat).replace(".00", "")
          , _ = (0,
        o.l)(v, theme.moneyFormat).replace(".00", "")
          , y = '<div class="options--small-servings"><div class="product-input__radio-buttons"><input type="radio" id="yes-jar" name="properties[Include jar]" checked="checked" value="Yes"/><label for="yes-jar" class="radio-button">Includes a free small jar</label><input type="radio" id="no-jar" name="properties[Include jar]" value="No" /><label for="no-jar" class="radio-button">No thanks - bag only</label></div></div>'
          , C = `<div class="options--medium-servings">\n  <div class="product-input__radio-buttons">\n    <input type="radio" id="yes-jar" class="js-jar-option" name="properties[Include Medium jar]" value/>\n    <label for="yes-jar" class="radio-button product-input__radio-text">Add a medium jar - <span class="product-input__radio-price"> ${j}</span></label>\n    <input type="radio" id="no-jar" class="js-jar-option" name="properties[Include Medium jar]" checked="checked" value="No" />\n    <label for="no-jar" class="radio-button product-input__radio-text">No thanks - bag only</label>\n  </div>\n</div>`
          , S = `<div class="options--large-servings">\n  <div class="product-input__radio-buttons">\n    <input type="radio" id="yes-jar" class="js-jar-option" name="properties[Include Large jar]" value/>\n    <label for="yes-jar" class="radio-button product-input__radio-text">Add a large jar - <span class="product-input__radio-price"> ${_}</span></label>\n    <input type="radio" id="no-jar" class="js-jar-option" name="properties[Include Large jar]" checked="checked" value="No" />\n    <label for="no-jar" class="radio-button product-input__radio-text">No thanks - bag only</label>\n  </div>\n</div>`;
        function w() {
            L(),
            function() {
                if (b) {
                    const e = b.variants;
                    let t = null;
                    document.querySelector("#AddToCart-product").addEventListener("click", (()=>{
                        const s = $(h)
                          , i = s.attr("data-variant")
                          , a = s.attr("data-variant-id")
                          , n = parseInt(i.split(" ")[0]);
                        if (n > 30 && !T()) {
                            t = n <= 100 ? e[1] : e[2];
                            document.querySelector("#yes-jar").checked && CartJS.addItem(t.id, 1, {
                                _associated_variant: a
                            }, {
                                success: function(e, t, s) {
                                    console.log("Added!")
                                },
                                error: function(e, t, s) {
                                    console.log("Error: " + s + "!")
                                }
                            })
                        }
                    }
                    ))
                }
            }(),
            $(m).change((function() {
                L()
            }
            ))
        }
        function k() {
            $(g).change((function() {
                const e = $(this).val();
                T() || ($(g).attr("name", "jar-option"),
                "No" === e && $(g).attr("name", "properties[Include Large jar]"))
            }
            ))
        }
        function T() {
            return "auto-refill" == $(p).attr("data-plan")
        }
        function L() {
            const e = $(h)
              , t = e.attr("data-variant")
              , s = parseInt(t.split(" ")[0])
              , i = $(u);
            let a = C
              , n = S;
            T() && (a = '<div class="options--medium-servings">\n  <div class="product-input__radio-buttons">\n    <input type="radio" id="yes-jar" name="properties[Include Medium jar]" checked="checked" value="Yes"/>\n    <label for="yes-jar" class="radio-button product-input__radio-text">Includes a free medium jar</label>\n    <input type="radio" id="no-jar" name="properties[Include Medium jar]" value="No" />\n    <label for="no-jar" class="radio-button product-input__radio-text">No thanks - bag only</label>\n  </div>\n</div>',
            n = '<div class="options--large-servings">\n  <div class="product-input__radio-buttons">\n    <input type="radio" id="yes-jar" name="properties[Include Large jar]" checked="checked" value="Yes"/>\n    <label for="yes-jar" class="radio-button product-input__radio-text">Includes a free large jar</label>\n    <input type="radio" id="no-jar" name="properties[Include Large jar]" value="No" />\n    <label for="no-jar" class="radio-button product-input__radio-text">No thanks - bag only</label>\n  </div>\n</div>'),
            window.SLS_STATE && window.SLS_STATE.hasOwnProperty("jar_product") ? 30 === s ? e.html(y) : 100 === s ? (e.html(a),
            k()) : s > 100 ? (e.html(n),
            k()) : (e.empty(),
            i.addClass("hide")) : "30 Servings" == t ? (e.html(y),
            i.removeClass("hide")) : (e.empty(),
            i.addClass("hide"))
        }
        (0,
        i.z2)("product", {
            onLoad() {
                w(),
                this.updatePriceOptions(),
                this.$container = $(this.container),
                this.namespace = `.${this.id}`,
                this.$container.on("variantChange", this.updateProductPrices.bind(this)),
                this.$container.on("variantChange", this.updateJarOptions.bind(this));
                let e = {
                    ...CartJS.cart
                };
                $(document).on("cart.requestStarted", (function(t, s) {
                    e = {
                        ...s
                    }
                }
                )),
                $(document).on("cart.requestComplete", (function(t, s) {
                    s.items.length;
                    if (s.items.length < e.items.length) {
                        const t = e.items.filter((e=>!s.items.find((t=>t.id === e.id)) && e.handle === b.handle));
                        t && t.length && t.forEach((e=>{
                            const {properties: {_associated_variant: t}} = e
                              , i = s.items.find((e=>parseInt(e.id) === parseInt(t)))
                              , a = s.items.findIndex((e=>parseInt(e.id) === parseInt(t)))
                              , n = {
                                ...i.properties || {}
                            }
                              , o = Object.keys(n).reduce(((e,t)=>(t.toLowerCase().indexOf("jar") > -1 ? e[`${t}`] = "No" : e[t] = n[t],
                            e)), {});
                            CartJS.updateItem(a + 1, i.quantity, o)
                        }
                        ))
                    }
                }
                ))
            },
            updatePriceOptions() {
                const e = $(".js-radio-button-price");
                e.length > 0 && e.each(((e,t)=>{
                    const s = $(t)
                      , i = parseInt(s.attr("data-price"))
                      , a = parseInt(s.attr("data-weight"))
                      , n = s.attr("data-per-serving");
                    if (i > 0 && a > 0) {
                        const e = (0,
                        o.l)(Math.round(i / a), theme.moneyFormat);
                        s.text(e + n)
                    }
                }
                ))
            },
            updateJarOptions(e) {
                const t = e.variant
                  , s = $(h);
                s.attr("data-variant", t.title),
                s.attr("data-variant-id", t.id),
                L()
            },
            updateProductPrices(e) {
                const t = e.variant;
                let s = 0
                  , i = 0
                  , a = 0
                  , n = 0;
                const h = $(c);
                if ("Default Title" !== t.option1) {
                    const e = parseInt(t.option1.replace(" Servings", ""), 10)
                      , c = (0,
                    o.l)(t.price, theme.moneyFormat);
                    if (a = 1 * e,
                    a > 0 && (s = (0,
                    o.l)(Math.round(t.price / a), theme.moneyFormat),
                    h && (n = parseInt(h.data("discount"), 10),
                    n > 0))) {
                        n /= 100,
                        n *= t.price;
                        const e = t.price - n;
                        i = (0,
                        o.l)(Math.floor(e / a), theme.moneyFormat),
                        $(d).text((0,
                        o.l)(e, theme.moneyFormat)),
                        h.text(i)
                    }
                    $(l).text(c),
                    $(r).text(s)
                }
            },
            onUnload() {
                this.$container.off(this.namespace)
            }
        });
        s(371);
        (0,
        i.z2)("recharge", {
            onLoad() {
                this.$container = $(this.container),
                this.namespace = `.${this.id}`,
                this.selectors = {
                    standard: ".js-price-standard",
                    subscription: ".js-price-subscription",
                    selectSubscription: ".js-select-subscription",
                    radio: ".js-purchase-type",
                    productRadio: ".js-product-radio-button",
                    btnStandard: ".js-button-label",
                    btnSubscription: ".js-button-label-subscription",
                    jar: ".js-need-a-jar",
                    jarLabel: ".js-jar-label",
                    quantity: "#Quantity-product"
                },
                this.classes = {
                    hidden: "hide",
                    off: "is-off",
                    isSubscription: "is-subscription",
                    subscriptionPrice: "price-per-serving--subscription"
                },
                this.value = "",
                this.init()
            },
            init() {
                this.bindOptionChange()
            },
            bindOptionChange() {
                $(document).on("change", this.selectors.radio, (e=>{
                    this.value = e.currentTarget.value,
                    this.showHideElements()
                }
                ))
            },
            showHideElements() {
                const e = $(this.selectors.standard)
                  , t = $(this.selectors.subscription)
                  , s = $(this.selectors.selectSubscription)
                  , i = $(this.selectors.btnStandard)
                  , a = $(this.selectors.btnSubscription)
                  , n = $(this.selectors.productRadio)
                  , o = $(this.selectors.jar)
                  , r = $(this.selectors.jarLabel)
                  , c = $(this.selectors.quantity);
                "onetime" === this.value ? (e.removeClass(this.classes.off),
                t.addClass(this.classes.hidden),
                s.addClass(this.classes.hidden),
                n.removeClass(this.classes.subscriptionPrice),
                i.removeClass(this.classes.hidden),
                a.addClass(this.classes.hidden),
                o.removeClass(this.classes.hidden),
                r.removeClass(this.classes.isSubscription),
                c.removeClass(this.classes.hidden)) : "autodeliver" === this.value && (t.removeClass(this.classes.hidden),
                s.removeClass(this.classes.hidden),
                e.addClass(this.classes.off),
                n.addClass(this.classes.subscriptionPrice),
                a.removeClass(this.classes.hidden),
                i.addClass(this.classes.hidden),
                o.addClass(this.classes.hidden),
                r.addClass(this.classes.isSubscription),
                c.addClass(this.classes.hidden))
            },
            onUnload() {
                this.$container.off(this.namespace)
            }
        });
        s(682);
        const x = window.jQuery;
        class O {
            constructor() {
                this.selectors = {
                    header: ".js-header",
                    main: "#main"
                },
                this.init()
            }
            getDOM() {
                this.DOM = {
                    header: document.querySelector(this.selectors.header),
                    main: document.querySelector(this.selectors.main)
                }
            }
            init() {
                this.getDOM(),
                this.bindScroll()
            }
            bindScroll() {
                const e = ["is-sticky"]
                  , t = this.DOM.header.parentNode;
                new Waypoint({
                    element: t,
                    handler: s=>{
                        "down" === s ? (t.classList.add(...e),
                        this.calcContentPadding()) : (t.classList.remove(...e),
                        this.DOM.main.style.paddingTop = 0)
                    }
                    ,
                    offset: -1
                })
            }
            calcContentPadding() {
                const e = this.DOM.header.offsetHeight;
                this.DOM.main.style.paddingTop = `${e}px`
            }
        }
        (0,
        i.z2)("scroll", {
            onLoad() {
                this.$container = x(this.container),
                this.namespace = `.${this.id}`,
                new O
            },
            onUnload() {
                this.$container.off(this.namespace)
            }
        });
        s(12);
        const I = window.jQuery
          , E = {
            selectors: {
                recent_research_toggle: ".js-toggle",
                recent_research_content: ".js-content",
                recent_research_item: ".js-item"
            },
            classes: {
                isOpen: "is-open"
            },
            init(e) {
                this.toggleDescription(e)
            },
            toggleDescription(e) {
                this.getToggles(e).forEach((t=>{
                    t.addEventListener("click", (()=>{
                        const s = t.closest(this.selectors.recent_research_item)
                          , i = s.querySelector(this.selectors.recent_research_content)
                          , a = s.classList.contains(this.classes.isOpen);
                        this.closeToggles(e),
                        a || (s.classList.add(this.classes.isOpen),
                        i.style.maxHeight = `${i.scrollHeight}px`)
                    }
                    ))
                }
                ))
            },
            getToggles(e) {
                return e.querySelectorAll(this.selectors.recent_research_toggle)
            },
            closeToggles(e) {
                this.getToggles(e).forEach((e=>{
                    const t = e.closest(this.selectors.recent_research_item);
                    if (t.classList.contains(this.classes.isOpen)) {
                        t.classList.remove(this.classes.isOpen);
                        t.querySelector(this.selectors.recent_research_content).style.maxHeight = "111px"
                    }
                }
                ))
            }
        };
        (0,
        i.z2)("recent-research", {
            onLoad() {
                this.$container = I(this.container),
                this.namespace = `.${this.id}`,
                E.init(this.container)
            },
            onUnload() {
                this.$container.off(this.namespace)
            }
        }),
        document.addEventListener("DOMContentLoaded", (()=>{
            (0,
            i.zD)("*")
        }
        ))
    },
    12: function() {
        const e = window.jQuery;
        e(document).ready((function() {
            const t = ".js-research-topic";
            let s = e(t).find(".research-topic__item").attr("data-to-show");
            s > 3 && (s = 3),
            s > 1 && e(t).slick({
                dots: !1,
                arrows: !0,
                infinite: !1,
                slidesToScroll: 1,
                slidesToShow: s,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            })
        }
        ))
    },
    521: function() {
        const e = window.jQuery;
        e(document).ready((function() {
            function t() {
                setTimeout((function() {
                    e(".cart__row__wrapper").each((function(t) {
                        var s = e(this).find(".cart__item__title").text()
                          , i = e(this).find("small.cart__item__interval");
                        s.indexOf("renew") < 0 && i.css("display", "block")
                    }
                    ))
                }
                ), 100)
            }
            window.location.href.indexOf("ajaxcart=open") >= 0 && e("body").toggleClass("cartjs__cart--is-active"),
            e(".CartToggle").click((function() {
                event.preventDefault(),
                e("body").toggleClass("cartjs__cart--is-active")
            }
            )),
            e(".cart-closer").click((function() {
                e("body").removeClass("cartjs__cart--is-active")
            }
            )),
            e(document).on("cart.requestComplete", (function(s, i) {
                e("body").hasClass("template-cart") || (e("body").addClass("cartjs__cart--is-active"),
                t())
            }
            )),
            e(document).click((function(t) {
                e("body").hasClass("template-cart") || e(t.target).closest(".cartjs__cart, .CartToggle").length || e("body").removeClass("cartjs__cart--is-active")
            }
            )),
            t()
        }
        ))
    },
    371: function() {
        if (document.location.href.indexOf("resultsinitial") > -1) {
            document.body.classList.add("pre-results");
            var e = window.location.href.replace(/%20/g, "-").replace(/%2C/g, "").replace(/resultsinitial/g, "resultsfinal");
            console.log(e),
            document.location.href = e
        }
        window.onload = function() {
            document.location.href.indexOf("resultsfinal") > -1 && (document.body.classList.add("quiz-results"),
            document.body.classList.remove("is-absolute"))
        }
    },
    973: function() {}
}, function(e) {
    var t = function(t) {
        return e(e.s = t)
    };
    e.O(0, [351], (function() {
        return t(868),
        t(973)
    }
    ));
    e.O()
}
]);
